import * as React from "react";
import { IdOrientation } from "../../../constants/IdOrientation";
import { IdLoca } from "../../../utils/i18n/IdLoca";
import { ReplacementLoca } from "../../../utils/i18n/ReplacementLoca";
import { IdTooltipAnchor, TooltipText } from "../../tooltip";
import { getResourceIcon } from "./getResourceIcon";
import { Icon } from "./Icon";
import { IdIcon } from "./IdIcon";
import { InnerIcon } from "./InnerIcon";
export var ResourceIcon = function (_a) {
    var styleId = _a.styleId, children = _a.children, _b = _a.orientation, orientation = _b === void 0 ? IdOrientation.Up : _b, _c = _a.tooltipAnchor, tooltipAnchor = _c === void 0 ? IdTooltipAnchor.Bottom : _c, _d = _a.hideTooltip, hideTooltip = _d === void 0 ? false : _d, resource = _a.resource, tooltipVerticalAdjust = _a.tooltipVerticalAdjust, unlockLevel = _a.unlockLevel, isLocked = _a.isLocked, isCompleted = _a.isCompleted;
    var resourceIcon = getResourceIcon(resource);
    var loca = resource.locaKey;
    var replacements = new Map();
    var disabled = unlockLevel != undefined || !!isLocked;
    if (unlockLevel != undefined) {
        replacements.set(ReplacementLoca.zero_0, unlockLevel.toString());
        loca = IdLoca.floatingText_levelCap;
    }
    var icon = disabled ? IdIcon.LockIcn : undefined;
    if (isCompleted) {
        icon = IdIcon.CheckIcn;
    }
    if (!hideTooltip) {
        return (React.createElement(TooltipText, { id: loca, replacements: replacements, anchor: tooltipAnchor, adjustVertical: tooltipVerticalAdjust },
            React.createElement("div", { className: "flex flex--guts" },
                React.createElement(Icon, { icon: resourceIcon, styleId: styleId, orientation: orientation },
                    React.createElement(InnerIcon, { styleId: styleId, icon: icon }, children)))));
    }
    return (React.createElement("div", { className: "flex flex--guts" },
        React.createElement(Icon, { icon: resourceIcon, styleId: styleId, orientation: orientation },
            React.createElement(InnerIcon, { styleId: styleId, icon: icon }, children))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/icon/ResourceIcon.tsx
// module id = 69
// module chunks = 3